import React, { useEffect, useState } from "react";

function InstallAppButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect iOS devices
    const ua = window.navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(ua));

    // Check if already installed (standalone mode)
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone
    ) {
      setIsInstalled(true);
    }

    // Detect mobile by screen width and user agent (extra safety)
    const checkMobile = () => {
      const isSmallScreen = window.innerWidth <= 768;
      const isMobileUA = /android|iphone|ipad|ipod|mobile/.test(ua);
      setIsMobile(isSmallScreen && isMobileUA);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);

    // Listen for beforeinstallprompt event (Chrome/Android)
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Don't show the button if:
  // - Not mobile
  // - Already installed
  if (!isMobile || isInstalled) return null;

  // iOS show manual instructions
  if (isIOS && !window.navigator.standalone) {
    return (
      <div className="install-ios-message" style={styles.iosMessage}>
        📱 To install this app, tap <b>Share</b> → <b>Add to Home Screen</b>
      </div>
    );
  }

  // If no deferred prompt available (can't trigger install), hide button
  if (!deferredPrompt) return null;

  // On button click, show install prompt
  const handleInstallClick = async () => {
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    if (choice.outcome === "accepted") {
      setDeferredPrompt(null);
    }
  };

  return (
    <button onClick={handleInstallClick} style={styles.button}>
      Install App
    </button>
  );
}

const styles = {
  button: {
    padding: "8px 14px",
    borderRadius: "6px",
    backgroundColor: "#000",
    color: "#fff",
    fontSize: "14px",
    border: "none",
    cursor: "pointer",
    alignSelf: "flex-start",
    transition: "background-color 0.3s",
  },
  iosMessage: {
    fontSize: "13px",
    color: "#000",
    background: "#f0f0f0",
    padding: "8px 12px",
    borderRadius: "6px",
  },
};

export default InstallAppButton;
